// Central list of Admin page keys. One entry per file in src/pages/Admin/content.
// key: kebab-case page key stored in accessRole.pages ("*" = all pages)
// tab: optionTab used by Admin/main.js and sidebarLeft.js (null = not opened from the Admin area)
// file: file name in src/pages/Admin/content
const PAGES = [
  { key: "staff-management", tab: "staffmanagement", file: "staffmanagement", label: "Quản lý nhân viên" },
  { key: "store-management", tab: "storeManagement", file: "storeManagement", label: "Quản lý cửa hàng" },
  { key: "win-prize", tab: "winPrize", file: "winPrize", label: "Thông tin trúng thưởng" },
  { key: "win-prize-vietlott", tab: null, file: "winPrizeVietlott", label: "Trả thưởng Vietlott" },
  { key: "win-prize-third-party", tab: "WinThirdParty", file: "winPrizeThirdParty", label: "Trúng ngoài hệ thống" },
  { key: "config-general", tab: "configGeneral", file: "configGeneral", label: "Thiết lập chung" },
  { key: "config-seo", tab: "configSeo", file: "configSeo", label: "Sửa thông tin Page" },
  { key: "pos-management", tab: "posManagerment", file: "posManagerment", label: "Quản lý mã POS" },
  { key: "config-reasons-not-allow-recharge", tab: "configReasonsNotAllowRecharge", file: "configReasonsNotAllowRecharge", label: "Lý do hủy yêu cầu nạp tiền" },
  { key: "config-reasons-not-allow-withdrals", tab: "configReasonsNotAllowWithdrals", file: "configReasonsNotAllowWithdrals", label: "Lý do hủy yêu cầu rút tiền" },
  { key: "config-reasons-not-allow-withdrals-cleark", tab: "configReasonsNotAllowWithdralsCleark", file: "configReasonsNotAllowWithdralsCleark", label: "Lý do hủy yêu cầu nạp tiền tại cửa hàng" },
  { key: "clerk-history", tab: "clerkHistory", file: "clerkHistory", label: "Lịch sử nhân viên" },
  { key: "accountant-history", tab: "accountantHistory", file: "accountantHistory", label: "Lịch sử kế toán" },
  { key: "admin-history", tab: "adminHistory", file: "adminHistory", label: "Lịch sử admin" },
  { key: "user-statistical", tab: "userStatistical", file: "userStatistical", label: "Thông tin khách hàng" },
  { key: "user-statistical-v2", tab: "userStatisticalV2", file: "UserStaticalV2", label: "Thông tin khách hàng v2" },
  { key: "customer-transactions", tab: "customerTransactions", file: "customerTransactions", label: "Thông tin giao dịch" },
  { key: "staff-statistical", tab: "staffStatistical", file: "staffStatistical", label: "Thông tin nhân viên" },
  { key: "staff-monitor", tab: "staffMonitor", file: "staffMonitor", label: "Hoạt động nhân viên" },
  { key: "revenue-statistics", tab: "revenueStatistics", file: "revenueStatistics", label: "Doanh thu" },
  { key: "revenue-third-party", tab: "revenueThirdParty", file: "revenueThirdParty", label: "Doanh thu đối tác" },
  { key: "money-holding-statistics", tab: "moneyHoldingStatistics", file: "moneyHoldingStatistics", label: "Tiền gửi theo kỳ" },
  { key: "money-holding-statistics-on-day", tab: "moneyHoldingStatisticsOnDay", file: "moneyHoldingStatisticsOnDay", label: "Tiền gửi theo ngày" },
  { key: "ticket-statistical", tab: null, file: "ticketStatistical", label: "Thống kê vé" },
  { key: "reject-ticket", tab: "rejectTicket", file: "rejectTicket", label: "Hủy vé" },
  { key: "order-management", tab: "OrderManagement", file: "orderManagement", label: "Đơn hàng ngoài hệ thống" },
  { key: "notifi-management", tab: "notifiCommonManagement", file: "notifiManagement", label: "Quản lý thông báo" },
  { key: "group-buy-manager", tab: "groupBuyManager", file: "groupBuyManager", label: "Nhóm mua chung" },
  { key: "kienthiet-manager", tab: "kenthietManager", file: "kienthietManager", label: "Kiến thiết" },
  { key: "change-term-ticket", tab: "changeTermKeno", file: "changeTermTicket", label: "Dời kỳ keno" },
  { key: "access-roles", tab: "accessRoles", file: "accessRoles", label: "Phân quyền trang" },
];

function keyOfTab(tab) {
  for (let i = 0; i < PAGES.length; i++) {
    if (PAGES[i].tab === tab) return PAGES[i].key;
  }
  return null;
}

// pages: array from accessRole.pages. "*" grants every page.
function canViewPages(pages, key) {
  if (!Array.isArray(pages)) return false;
  return pages.indexOf("*") !== -1 || pages.indexOf(key) !== -1;
}

function getPages() {
  const userInfo = require("../../utils").getUserinfo();
  if (!userInfo || !userInfo.accessRole) return null;
  return userInfo.accessRole.pages;
}

// Current user may view the Admin page with this key
function canView(key) {
  return canViewPages(getPages(), key);
}

// Returns tab when allowed, else the first allowed menu tab, else null
function resolveTab(tab, pages) {
  if (canViewPages(pages, keyOfTab(tab))) return tab;
  for (let i = 0; i < PAGES.length; i++) {
    if (PAGES[i].tab && canViewPages(pages, PAGES[i].key)) return PAGES[i].tab;
  }
  return null;
}

module.exports = {
  PAGES: PAGES,
  keyOfTab: keyOfTab,
  canViewPages: canViewPages,
  canView: canView,
  getPages: getPages,
  resolveTab: resolveTab,
};
